import docReady from './Functions/docReady';
import Vue from 'vue'
import { buildVisiblePrice } from './Functions/buildVisiblePrice.js'

docReady(function () {
    document.body.classList.add('page-jobs');

    // Kasutatakse ainult Jobs/History lehe puhul
    const usageDates = document.querySelectorAll('[data-utcdate]');
    var currentTimeZone = Intl.DateTimeFormat().resolvedOptions();

    usageDates.forEach(usageDate => {
        var date = new Date(usageDate.dataset.utcdate).toLocaleString(currentLanguageCode, { timeZone: currentTimeZone.timeZone });

        usageDate.innerHTML = date;
    });
});

if (document.getElementById('table') && document.getElementById('table').classList.contains('payments-table')) {
    const historyTable = new Vue({
        el: '#table.payments-table',
        data: {

        },
        computed: {

        },
        methods: {
            getPrice: function (pagePrice) {
                return (isNaN(parseInt(pagePrice)) || pagePrice <= 0) ? '-' : buildVisiblePrice(pagePrice, model.currencyInfo, 2, 4);
            },
        }
    })
}